import React from "react";
import { ShieldCheckIcon, CheckCircle2Icon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { guaranteeItems } from "../../data/content";
export function Guarantee() {
  return <section className="w-full bg-cream px-4 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-147" data-mp="24myd0kqdjrnd">
      <div className="mx-auto max-w-2xl" data-id="element-148" data-mp="29e6nlk3fxj24">
        <div className="rounded-3xl border-2 border-dashed border-gold bg-white p-6 sm:p-10" data-id="element-149" data-mp="29f80zv7xihn0">
          <div className="flex flex-col items-center text-center" data-id="element-150" data-mp="2ecrqjra2ugu9">
            <div className="relative flex h-24 w-24 items-center justify-center rounded-full bg-gold" data-id="element-151" data-mp="2jb1lc0rw3ffc">
              <ShieldCheckIcon className="h-12 w-12 text-navy-deep" aria-hidden="true" data-id="element-152" data-mp="2oc8uo49okmo4" />
              <span className="absolute -bottom-2 rounded-full bg-navy px-3 py-0.5 text-xs font-extrabold text-white" data-id="element-153" data-mp="2sd2ikxn4i1h0">7 DAYS</span>
            </div>
            <h2 id="guarantee-title" className="mt-6 font-serif text-3xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-154" data-mp="tz99zwqg129z">
              My 7-day guarantee
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-ink/80" data-id="element-155" data-mp="3sm85ssvy1cpq">
              I want you to actually explore the Decision Lab™ before deciding whether it belongs in your professional learning workflow. For 7 days, you can:
            </p>
          </div>

          <ul className="mx-auto mt-6 grid max-w-md gap-2.5" data-id="element-156" data-mp="3dwsijmvmfpes">
            {guaranteeItems.map(item => <li key={item} className="flex items-center gap-3 text-base font-medium text-ink" data-id="element-157" data-mp="ffg696p8op1q">
                <CheckCircle2Icon className="h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-158" data-mp="afadfn78gwi2" />
                {item}
              </li>)}
          </ul>

          <p className="mt-6 text-center text-base leading-relaxed text-muted" data-id="element-159" data-mp="5ijw6wjozuv2">
            If you decide the system isn't useful for your professional learning, you can request a refund according to the purchase terms.
          </p>
          <p className="mt-3 text-center font-serif text-xl font-bold text-navy" data-id="element-160" data-mp="2l7d5ysob5ogr">No complicated process. Just explore it and decide for yourself.</p>
        </div>

        <CtaButton label="Try it risk-free for 7 days" className="mt-10" data-id="element-161" data-mp="1d6bjvetd6lod" />
      </div>
    </section>;
}